import { z } from 'zod';
import { UserSchema } from 'packages/lib/api/annotations-ops/contract/user-types';
import { WorkflowPerformanceSchema } from 'packages/lib/api/annotations-ops/contract/workflow-performance-types';

export const UserProfileSchema = UserSchema.extend({
  workflowPerformance: z
    .object({
      'lidar-box': WorkflowPerformanceSchema,
      'video-event': WorkflowPerformanceSchema,
      enrichment: WorkflowPerformanceSchema,
    })
    .partial(),
});
export type UserProfile = z.infer<typeof UserProfileSchema>;
